import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { SocketActions } from '@store/socketSaga'
import { UserActions } from '@storeOld/reducers/user/actions'
import { put, select } from 'redux-saga/effects'

import { InternalStorageActions, type StorageActions } from '../actions'

export function* removeAttachments({
  payload,
}: ReturnType<typeof StorageActions.removeAttachments>) {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )
  const owner: boolean = yield select(
    migrationProjectSelector.getIsCurrentUserOwnerOfProject
  )

  if (!projectId) {
    return
  }

  if (owner) {
    yield put({
      type: UserActions.DECREASE_STORAGE_LIMITS,
      payload,
    })
  }

  const internalActions = InternalStorageActions.removeAttachments(payload)

  yield put(internalActions)

  yield put(
    SocketActions.emit({
      eventName: 'sync',
      payload: internalActions,
    })
  )
}
